<template>
  <section class="list-container">
    <TemplateCard create @create="handleShowCreate" />

    <TemplateCard
      v-for="template in templates"
      :key="template.id"
      :create="false"
      :template="template"
      @update="emit('update')"
    />
  </section>

  <CreateTemplateModal v-if="openCreateModal" v-model:open="openCreateModal" />

  <RestrictionChangePlanModal
    title="Realiza un upgrade y accede a todo el poder de Beex."
    v-model:open="openRestriction"
  >
    <template #description>
      Tu plan {{ PlanTypeText[plan as PlanType] }} no incluye este módulo.
      Solicita un upgrade tu plan para potenciar tu ambiente de trabajo.
    </template>
  </RestrictionChangePlanModal>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";

import { Template } from "@/@types/flows/emailTemplates";

import TemplateCard from "@/app/flows/emailTemplates/components/cards/TemplateCard.vue";
import CreateTemplateModal from "@/app/flows/emailTemplates/components/modals/CreateTemplateModal.vue";
import { PlanType, PlanTypeText } from "@/app/common/types";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { ActionPlanStrategy } from "@/app/common/utils/enums";
import EventBus from "@/app/shared/utils/eventBus";

defineProps<{ templates: Template[] }>();

const emit = defineEmits<{ update: [] }>();

const store = useStore();

const user = computed(() => store.getters["getDataUser"]);

const openCreateModal = ref(false);
const plan = computed(() => user.value?.change_custom_plan?.plan);
const openRestriction = ref(false);

const validateActionPlanHeader = () => {
  if (plan.value == PlanType.Voice) {
    store.commit("SET_ACTION_PLAN_HEADER", ActionPlanStrategy.Upgrade);
  } else {
    store.commit("SET_ACTION_PLAN_HEADER", null);
  }
};

const handleShowCreate = () => {
  if (plan.value == PlanType.Voice)
    openRestriction.value = true
  else
    openCreateModal.value = true
}

EventBus.on("SHOW_RESTRICTION_PLAN", () => {
  openRestriction.value = true
});

watch(user, () => {
  validateActionPlanHeader();
})

watch(plan, () => {
  validateActionPlanHeader();
})

onMounted(() => {
  validateActionPlanHeader();
});

onUnmounted(() => {
  store.commit("SET_ACTION_PLAN_HEADER", null);
});
</script>

<style scoped lang="sass">
.list-container
  gap: 12px
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr))
</style>
